import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.8, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const MaskedLines = ({ lines, className, delay = 0.1, as: Tag = "h1" }) => (
  <Tag className={className}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden pb-[0.09em] -mb-[0.09em]">
        <motion.span
          className={`block ${line.cls ?? ""}`}
          initial={{ y: "112%" }}
          animate={{ y: 0 }}
          transition={{ delay: delay + i * 0.13, duration: 0.95, ease: EASE }}
        >
          {line.text}
        </motion.span>
      </span>
    ))}
  </Tag>
);
